import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      margin: '0px auto',
      flex: 1,
      height: '80vh',
      maxHeight: '659px',
      width: "100%"
    },
    headerModal: {
      padding: '16px 24px',
      justifyContent: 'space-between',
      borderRadius: '0px 0px 8px 8px',
      height: '16%',
      display: 'grid',
      alignItems: 'center',
      gridColumnGap: 20,
      gridTemplateColumns: '5fr 2fr 3fr',
    },
    customDot: {
      marginTop: 0,
      '&>div': {
        marginRight: 6,
        '&>div': {
          width: 12,
          height: 12,
        }
      }
    },
    titleModal: {
      font: theme.custom.font.montserrat16,
      '& p:first-child': {
        font: 'normal normal 700 18px/32px Public-Sans',
      },
      '& p': {
        color: theme.custom.colors.primary,
      }
    },
    dFlexRight: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 15
    },
    bodyModalList:{
      padding: '24px 47px',
      overflowY: 'scroll',
      height: '72%',
      // width: 1029,
      // height: 400,
      // maxHeight: '100%'
    },
    btnAddRecipeBody: {
      '& button': {
        height: 32,
        background: theme.custom.colors.primary,
        fontWeight: 'bold',
        color: theme.custom.colors.white,
        fontSize: theme.custom.fontSize.size16,
        fontFamily: theme.custom.fontFamily.bold,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        '&:hover': {
          background: theme.custom.colors.primary,
        },
      },
    },
    footerModal: {
      height: '12%',
      padding: '16px 24px',
      display: 'flex',
      boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
      justifyContent: 'flex-end',
      alignItems: 'center',
      font: 'normal normal 500 16px/24px Public-Sans',
      '&>div:first-child': {
        marginRight: 24,
        cursor: 'pointer',
      }
    },
    buttonBack: {
      '& button': {
        height: 32,
        background: theme.custom.colors.borderGrey,
        fontWeight: 'bold',
        fontSize: theme.custom.fontSize.size16,
        fontFamily: theme.custom.fontFamily.bold,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        color: '#333333',
        marginRight: 24,
        '&:hover': {
          background: theme.custom.colors.borderGrey,
        },
      },
    },
    textButtonBack: {
      font: theme.custom.font.montserrat16Bold,
      color: theme.custom.colors.borderGrey,
      marginLeft: '7px',
    },
    iconLoading: {
      marginLeft: '15px',
      '& svg': {
        color: '#fff',
      },
    },
  };
});

export default useStyles;
